import { useOutletContext  } from "react-router-dom";
import { Column } from '@ant-design/plots';
import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'antd';
import { useSelector } from "react-redux";
import DashboardAPI from "../../restAPI/DashboardAPI";

const StackedBarChart = ({ isDarkMode }) => {
  const { token } = useSelector(state => state.auth);
  const [barchartData, setBarchartData] = useState([]);
  const {groupId, companyId} = useOutletContext();

  useEffect(() => {
    console.log("StackBar chart companyId:",companyId ,"groupId:",groupId)
    getBarChartData();
  }, [groupId, companyId]);

  const getBarChartData = async () => {
    try {
        if(localStorage.getItem('companyId') !==null){
          const res = await DashboardAPI.getDocSubmissionStatusData(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'));
          if (res?.data) {
            console.log("API Response stacked bar:", JSON.stringify(res.data));
            const transformedData = transformData(res.data);
            setBarchartData(transformedData);
          }
          else{
            setBarchartData([]);
          }
       }
    } catch (err) {
      console.log("Error fetching data:", err.message);
    }
  };

  const transformData = (apiData) => {
    //const statuses = ['pending', 'extracted', 'success', 'deleted', 'failed', 'canceled', 'failed-submittable'];

    const statuses = ['pending','extracted','deleted','success','failed','cancelled','failed submittable', 'failed validation', 'duplicate', 'on hold']

    let transformed = [];

    apiData.forEach(item => {
      statuses.forEach(status => {
        transformed.push({
          date: item.date,
          status: status.charAt(0).toUpperCase() + status.slice(1), 
          count: item[status] || 0
        });
      });
    });

    return transformed;
  };

  // Define a color mapping for each status
  const colorMap = {
    'Pending': '#4da6ff',
    'Extracted': '#a8d8b8',
    'Deleted': '#a8a4d8',
    'Success':'#F1C40F',
    'Failed': '#ffa07a',
    'Cancelled': '#ffd699',
    'Failed submittable': '#ff6666',
    'Failed validation':'#008b8b',
    'Duplicate': '#ff69b4',
    'On hold': '#FF8C00',
  };

  const config = {
    theme: isDarkMode ? "classicDark" : "classic",
    data: barchartData, 
    xField: 'date',
    yField: 'count',
    colorField: 'status',
    stack: true,
    height: 530,
    axis: {
      y: {
        labelFormatter: '~s',
        title: {
          text: 'Document Count',
          style: {
            fontSize: 14,
            fontWeight: 'bold',
            fill: isDarkMode ? '#fff' : '#000',
            rotate: -90,
          },
          position: 'middle',
          offset: 50,
        },
      },
      x: {
        labelSpacing: 12,
        intervalPadding: 20,
        tickCount: barchartData.length,
        style: {
          labelTransform: 'rotate(90)',
          textAlign: 'end',
          textBaseline: 'middle',
        },
        labelFormatter: (date) => date,
      },
    },
    legend: false,
    color: ({ status }) => colorMap[status],
    style: {
      fill: ({ status }) => colorMap[status],
      columnWidthRatio: 0.6,
      radiusTopLeft: 6,
      radiusTopRight: 6,
    },
  };

  const CustomLegend = () => (
    <Row justify="center" style={{ marginBottom: 16 }}>
      {Object.entries(colorMap).map(([status, color]) => (
        <Col key={status} style={{ margin: '4px 8px', display: 'flex', alignItems: 'center' }}>
          <span
            style={{
              width: 16,
              height: 16,
              backgroundColor: color,
              display: 'inline-block',
              marginRight: 8,
              borderRadius: '50%',
            }}
          />
          <span>{status}</span>
        </Col>
      ))}
    </Row>
  );

  return (
    <Card title="Document Submission Status - Last 30 Days" style={{ width: '100%' }}>
      <CustomLegend />
      <Column {...config} />
    </Card>
  );
};

export default StackedBarChart;
